import blog1 from "../../images/blog/blog-868x514-1.jpg";
import blog2 from "../../images/blog/blog-868x514-2.jpg";
import blog3 from "../../images/blog/blog-868x514-3.jpg";
import blog4 from "../../images/blog/blog-868x514-4.jpg";
import blog5 from "../../images/blog/blog-868x514-5.jpg";

export const blogs = [
  {
    blogImg: blog1,
    title: "Why Choose a Leading HR Consultancy in Calicut, Kerala?",
    description:
      "Running a business in today’s competitive environment requires more than just good products and services. It demands",
    time: "13 AUG, 21",
    link: "/blogs/why-choose-a-leading-hr-consultancy-in-calicut-kerala",
  },
  {
    blogImg: blog2,
    title: "Recruitment Outsourcing in Kerala: Why SMEs Should Consider It",
    description:
      "Recruitment is often one of the most time-consuming and costly processes for businesses. For small and medium",

    time: "14 AUG, 21",
    link: "/blogs/recruitment-outsourcing-in-kerala",
  },
  {
    blogImg: blog3,
    title: "Top 10 Payroll Mistakes SMEs in Kerala Must Avoid",
    description:
      "Managing payroll is one of the most challenging aspects for small and medium enterprises (SMEs) in Kerala.",

    time: "15 AUG, 21",
    link: "/blogs/payroll-outsourcing-in-kerala",
  },
  {
    blogImg: blog4,
    title: "The Complete Guide to HR Compliance in Kerala",
    description:
      "Running a business in Kerala is not only about offering good products or services. It also means",

    time: "15 AUG, 21",
    link: "/blogs/the-complete-guide-to-hr-compliance-in-kerala",
  },
  {
    blogImg: blog5,
    title: "How to Choose the Right HR Consultancy in Calicut",
    description:
      "Finding and keeping the right talent is one of the biggest challenges for small and medium businesses in Kerala.",

    time: "15 AUG, 21",
    link: "/blogs/how-to-choose-the-right-hr-consultancy-in-calicut",
  },
];
